import { useEffect, useState } from "react";
//import UserModelsEnum, { FaqUserTypes } from "../helpers/enums/UserModelsEnum";
//import { useAuth } from '../context/AuthContext';
import { getAllProductsCategories } from "../services/ProductsCategories";


function useFetchCategories() {

    const [filter, setFilter] = useState({stateParam: 'ACTIVE', showRows: 20, pagePara: 0});
    const [lastPage, setLastPage] = useState(false);
    const [response, setResponse] = useState([]);
    const [loading, setLoading] = useState(true);

   // const {user} = useAuth();

    const getCategories = async () => {

        setLoading(true);

        let type;
    
        // if(user.model === UserModelsEnum.Broker || user.model === UserModelsEnum.Developer) {
        //   type = 'SUDO';
        // }
    
        try {
          const res = await getAllProductsCategories({...filter, typeParam: type});
          setResponse(res.data);
          if(res.data.empty || res.data.last) setLastPage(true);
        } catch (error) {
          console.error(error);
        } finally{
          setLoading(false);
        }
    
    }

    useEffect(() => {

       getCategories();
    
    }, []);

    return {loading, response, lastPage, filter, setFilter};


}

export default useFetchCategories